import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import '@cloudscape-design/global-styles/index.css';
import { BrowserRouter } from 'react-router-dom';

import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '@@/lib/QueryClient';

import CompanyProvider from '@@/contexts/CompanyProvider';
import App from './app/app';
import { StorageHelper } from './lib/StorageHelper';
import { Authenticator } from '@aws-amplify/ui-react';

// remove this when we get rid of cloudscape
import './cloudscapeOverride.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const theme = StorageHelper.getTheme();
StorageHelper.applyTheme(theme);

root.render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <Authenticator.Provider>
        <BrowserRouter>
          <CompanyProvider>
            <App />
          </CompanyProvider>
        </BrowserRouter>
      </Authenticator.Provider>
    </QueryClientProvider>
  </StrictMode>
);
